<template>
  <div id="login">
    <div class="loginContent">
      <div class="loginFloor">
        <el-input
          placeholder="请输入账号"
          type="text"
          v-model="account"
        ></el-input>
      </div>
      <div class="loginFloor">
        <el-input
          placeholder="请输入密码"
          type="password"
          v-model="password"
        ></el-input>
      </div>
      <div class="loginFloor">
        <el-button type="primary" @click="doLogin">登 录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      account: "",
      password: ""
    };
  },
  methods: {
    async doLogin() {
      if (!this.account) {
        this.$message.error('账号不能为空')
        return false;
      }
      if (!this.password) {
        this.$message.error("密码不能为空")
        return false;
      }
      const res = await axios.post(
        "https://xlogin.us/api/my_login.php",
        qs.stringify({
          account: this.account,
          password: this.password
        })
      );
      if (res.data.code === 200) {
        sessionStorage.setItem('account',this.account)
        sessionStorage.setItem('uid',res.data.info.uid)
        this.$router.push("/");
      } else {
        this.$message.error(res.data.msg)
      }
    }
  }
};
</script>

<style  lang="less" scoped>
#login {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url(../assets/images/loginBg.png) no-repeat center center;
  background-size: cover;
  .loginContent {
    position: absolute;
    width: 350px;
    padding: 15px;
    box-sizing: border-box;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #ddd;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    .loginFloor {
      margin-bottom: 10px;
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>